module.exports = __webpack_public_path__ + "img/f5.bb6e7b3b.jpg";